import { useMemo, useState } from 'react'
import { DataGrid } from '@/components/blocks/data-grid'
import { applyTableState, useTableState } from '@/components/blocks/data-table'
import { GameConfigShell } from '@/components/config/GameConfigShell'
import { ARENA_COLUMNS } from '@/components/config/Grids'
import { ARENAS } from '@/fixtures'
import type { Arena } from '@/models'

/* Still on fixtures: this section has no table of its own yet. When it gets
 * one, the controller hands rows down as props and only the two lines that
 * reach for ARENAS change. */
export default function GameConfigArenas() {
  const { state, setState } = useTableState({ pageSize: 50 })
  const [rows, setRows] = useState<Arena[]>(ARENAS)
  const [dirty, setDirty] = useState<Set<string>>(new Set())

  const view = useMemo(() => applyTableState(rows, ARENA_COLUMNS, state), [rows, state])

  const handleCellChange = (row: Arena, key: string, value: string) => {
    setRows((previous) =>
      previous.map((entry) => (entry.id === row.id ? { ...entry, [key]: value } : entry)),
    )
    setDirty((previous) => new Set(previous).add(row.id))
  }

  return (
    <GameConfigShell
      section="Arenas"
      description="Arena unlocks and their trophy gates."
      dirtyCount={dirty.size}
      onRevert={() => {
        setRows(ARENAS)
        setDirty(new Set())
      }}
    >
      <DataGrid
        columns={ARENA_COLUMNS}
        rows={view.rows}
        total={view.total}
        state={state}
        onStateChange={setState}
        rowKey={(row) => row.id}
        onCellChange={handleCellChange}
        noun="arenas"
        paginate={false}
        maxHeight={560}
      />
    </GameConfigShell>
  )
}
